export const regex = {
  emailValidation: /^\w+([\.+-]?\w?)*@\w+([\.+-]?\w+)*(\.\w{2,4})+$/,
  passwordValidation:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~`!@#$%^&*()_\+=\-\[\]{}\\|<>\.,\/\?'":;])[A-Za-z\d~`!@#$%^&*()_\+=\-\[\]{}\\|<>\.,\/\?'":;]{8,}/,
};
